module.exports = __webpack_public_path__ + "fonts/drop-menu-s-white.e2c22b2ab41fb959ab8c32a81ac5a398.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/indicators/drop-menu-s-white.png
// module id = 825
// module chunks = 9